export default "__VITE_ASSET__7362d73a__"